import AWS from 'aws-sdk';
import AWSOps, { appConfig } from '../config/AWSOps';
import {
  getValueFromPartialKey,
  getKeyFromString,
  setValue
} from '../utils/localStorageManager';
import { api as apiBuilder } from '../utils/apiBuilder';

// eslint-disable-next-line no-unused-vars
const buildEndpoint = (operation, host) => {
  const endpoint = apiBuilder.buildApi(operation);
  return endpoint;
};

export const getIdToken = async () => {
  // eslint-disable-next-line no-unused-vars
  const userEmail =
    getValueFromPartialKey('reduxPersist:user') &&
    JSON.parse(getValueFromPartialKey('reduxPersist:user')).email;
  const idToken = getValueFromPartialKey('idToken');

  const tokenLastUpdate = getValueFromPartialKey('tokenLastUpdate');
  if (tokenLastUpdate !== 'null') {
    const lastDate = new Date(tokenLastUpdate);
    const currentDate = new Date();
    const diff = Math.abs(currentDate - lastDate);
    const minutes = Math.floor(diff / 1000 / 60);

    if (minutes >= 30) {
      const refreshToken = getValueFromPartialKey('refreshToken');

      AWS.config.update({
        region: 'us-east-1',
        accessKeyId: 'accessKeyId',
        secretAccessKey: 'secretAccessKey'
      });

      const awsService = new AWS.CognitoIdentityServiceProvider();
      const authParams = {
        AuthFlow: 'REFRESH_TOKEN_AUTH',
        ClientId: appConfig.ClientId,
        AuthParameters: {
          REFRESH_TOKEN: refreshToken
        },
        ClientMetadata: {}
      };

      const newToken = await new Promise(async (resolve, reject) => {
        await awsService.initiateAuth(authParams, (err, data) => {
          if (err) {
            reject(null);
          }

          if (data) {
            setValue(getKeyFromString('tokenLastUpdate'), new Date());
            setValue(
              getKeyFromString('accessToken'),
              data.AuthenticationResult.AccessToken
            );
            setValue(
              getKeyFromString('idToken'),
              data.AuthenticationResult.IdToken
            );
            AWSOps.config.credentials = new AWSOps.CognitoIdentityCredentials({
              IdentityPoolId: appConfig.IdentityPoolId,
              Logins: {
                [appConfig.LoginId]: data.AuthenticationResult.IdToken
              }
            });

            return resolve(data.AuthenticationResult.IdToken);
          }

          return resolve(idToken);
        });
      });

      return newToken;
    }
    return idToken;
  }
  return idToken;
};

export const makePost = async (operation, data, host) => {
  const endpoint = buildEndpoint(operation, host);

  const token = await new Promise(async (resolve, reject) => {
    await getIdToken().then(async (result) => resolve(result));
    reject(null);
  });

  const formatedData = JSON.stringify(data);
  const result = await fetch(endpoint, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      AlexiaAuth: token
    },
    method: 'POST',
    body: formatedData
  });
  const json = await result.json();
  return json;
};

export const makePostWithoutToken = async (operation, data, host) => {
  const endpoint = buildEndpoint(operation, host);

  // eslint-disable-next-line no-unused-vars
  const token = await new Promise(async (resolve, reject) => {
    await getIdToken().then(async (result) => resolve(result));
    reject(null);
  });

  const formatedData = JSON.stringify(data);
  const result = await fetch(endpoint, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: formatedData
  });

  const json = await result.json();
  return json;
};

export const makePut = async (operation, data, host) => {
  const endpoint = buildEndpoint(operation, host);

  const token = await new Promise(async (resolve, reject) => {
    await getIdToken().then(async (result) => resolve(result));
    reject(null);
  });

  const formatedData = JSON.stringify(data);
  const result = await fetch(endpoint, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      AlexiaAuth: token
    },
    method: 'PUT',
    body: formatedData
  });

  const json = await result.json();
  return json;
};

export const makeGet = async (operation, host) => {
  const endpoint = buildEndpoint(operation, host);

  const token = await new Promise(async (resolve, reject) => {
    await getIdToken().then(async (result) => resolve(result));
    reject(null);
  });

  const result = await fetch(endpoint, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      AlexiaAuth: token
    },
    method: 'GET'
  });

  const json = await result.json();
  return json;
};

// eslint-disable-next-line no-unused-vars
export const makeDelete = async (operation, data, host) => {
  const endpoint = `${apiBuilder.buildApi(operation)}`;

  const token = await new Promise(async (resolve, reject) => {
    await getIdToken().then(async (result) => resolve(result));
    reject(null);
  });

  const formatedData = JSON.stringify(data);
  const result = await fetch(endpoint, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      AlexiaAuth: token
    },
    method: 'DELETE',
    body: formatedData
  });

  const json = await result.json();
  return json;
};

export const makeGetWithParam = async (operation, host, parameters) => {
  // at the moment, two use cases for parameters, number and ?*
  const endpoint = `${apiBuilder.buildApi(operation)}${
    `${parameters}`.indexOf('?') !== -1 ? '' : '/'
  }${parameters}`;

  // Looks like if it is running on local, there is no need to get the auth toke.
  const token = await new Promise(async (resolve, reject) => {
    await getIdToken().then(async (result) => resolve(result));
    reject(null);
  });

  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    AlexiaAuth: token
  };

  

  const result = await fetch(endpoint, {
    headers,
    method: 'GET'
  });

  const json = await result.json();
  return json;
};

export const makeGetWithoutToken = async (
  operation,
  host,
  parameters,
  customHeaders
) => {
  const endpoint = `${apiBuilder.buildApi(operation)}/${parameters}`;

  let headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };

  if (customHeaders) {
    headers = { ...headers, ...customHeaders };
  }

  const result = await fetch(endpoint, {
    headers,
    method: 'GET'
  });

  const json = await result.json();
  return json;
};

export const makeGetWithoutTokenParam = async (operation) => {
  const endpoint = `${apiBuilder.buildApi(operation)}`;
  console.log('url endpoint', endpoint);

  const result = await fetch(endpoint, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    method: 'GET'
  });

  const json = await result.json();
  return json;
};



// WEBPACK FOOTER //
// ./src/services/ServiceManager.js